import { Checkbox, Flex, Space } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import Search from "antd/es/input/Search";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { DownloadButtonWithIcon } from "src/modules/DownloadButtonWithIcon/DownloadButtonWithIcon";

export type CheckBoxFilter = {
  property: string;
  label: string;

  disabled?: boolean;
  onChange?: (property: string, value?: boolean, filterString?: string) => void;
};

interface IDataTableControlPanel {
  filterValue?: string;
  placeHolder?: string;
  onFilterChange: (
    value?: string,
    secondaryFilterProperty?: string,
    secondaryFilterValue?: boolean,
  ) => void;
  checkBoxFilter?: CheckBoxFilter;
  onDownloadClick?: () => Promise<void>;
  checkBoxFilterValue: boolean;
  setCheckBoxFilterValue: (checked: boolean) => void;
}
export const DataTableControlPanel: React.FC<IDataTableControlPanel> = ({
  filterValue,
  placeHolder = "",
  onFilterChange,
  checkBoxFilter,
  onDownloadClick,
  checkBoxFilterValue,
  setCheckBoxFilterValue,
}) => {
  const [localInputValue, setLocalInputValue] = useState<string>();

  useEffect(() => {
    setLocalInputValue(filterValue);
  }, [filterValue]);

  const onInputChange = useCallback(
    (_ev: ChangeEvent<HTMLInputElement>) => {
      setLocalInputValue(_ev.target.value);

      onFilterChange(
        _ev.target.value,
        checkBoxFilter?.property,
        checkBoxFilterValue,
      );
    },
    [checkBoxFilter?.property, checkBoxFilterValue, onFilterChange],
  );

  const onCheckboxChange = useCallback(
    (_ev: CheckboxChangeEvent) => {
      setCheckBoxFilterValue(_ev.target.checked);

      if (checkBoxFilter?.onChange) {
        checkBoxFilter.onChange(
          checkBoxFilter.property,
          _ev.target.checked,
          filterValue,
        );
      }
    },
    [checkBoxFilter, filterValue, setCheckBoxFilterValue],
  );

  return (
    <Flex justify="space-between" align="center" style={{ padding: "10px 0" }}>
      <Space size="large" wrap>
        <Space>
          <Search
            placeholder={placeHolder}
            value={localInputValue}
            onChange={onInputChange}
            style={{ width: 250 }}
            allowClear
          />
        </Space>
        {checkBoxFilter && (
          <Space>
            <Flex align="center" key={`c-filter`}>
              <Checkbox
                checked={checkBoxFilterValue}
                disabled={checkBoxFilter?.disabled}
                onChange={onCheckboxChange}
              >
                <Flex justify="space-between">
                  <span style={{ fontWeight: "600" }}>
                    {checkBoxFilter.label}
                  </span>
                </Flex>
              </Checkbox>
            </Flex>
          </Space>
        )}
      </Space>
      {onDownloadClick && (
        <DownloadButtonWithIcon top={-12} onClick={onDownloadClick} />
      )}
    </Flex>
  );
};
